import { Skeleton } from '@aimsos/ui';

/** Placeholder while a GS detail preview (claim / change-request) is in flight. */
function DetailBodySkeleton() {
  return (
    <div className="flex flex-col gap-4" aria-busy="true" aria-live="polite">
      <Skeleton height={12} width="28%" />
      <Skeleton height={14} width="92%" />
      <Skeleton height={14} width="78%" />
      <Skeleton height={12} width="24%" />
      <Skeleton height={64} width="100%" borderRadius={8} />
    </div>
  );
}

export default DetailBodySkeleton;
